import { render } from "./BaseLoadingMain.vue?vue&type=template&id=44175914&scoped=true"
import script from "./BaseLoadingMain.vue?vue&type=script&lang=js"
export * from "./BaseLoadingMain.vue?vue&type=script&lang=js"

import "./BaseLoadingMain.vue?vue&type=style&index=0&id=44175914&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44175914"]])

export default __exports__